import i18n from "src/locales/i18n";

import { BusinessErrorCodes } from "src/types/business-errors";

export const getSendEmailErrorMessage = (e: any): string => {
  if (e?.data?.error_code === BusinessErrorCodes.ActiveEmailConnectionNotAvailable) {
    return i18n.t('email_sync.api.send_email.requires_active_connection');
  }

  return i18n.t('email_sync.api.send_email.default_error');
};

export const getCompleteConnectionErrorMessage = (e: any): string => {

  if (e?.data?.error_code === BusinessErrorCodes.EmailConnectorEmailMismatch) {
    return i18n.t('email_sync.api.complete_connection.email_mismatch');
  }

  if (e?.data?.error_code === BusinessErrorCodes.ActiveEmailConnectionExists) {
    return i18n.t('email_sync.api.complete_connection.already_connected');
  }

  return i18n.t('email_sync.api.complete_connection.default_error');
};